// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"c2216900","container":"e942269c","contentContainer":"b5600c24"};